import React, { useRef } from 'react';

import { Box, FormControl, Input, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { primitive } from 'styles/constants/primitives';

import { IVehicleDescriptionProps } from './types';

const DescriptionInput = Input.withConfig({
  width: '100%',
  borderWidth: 1,
  borderColor: Styles.color.grey.three,
  borderStyle: 'solid',
  borderTopLeftRadius: Styles.borderRadius,
  borderTopRightRadius: Styles.borderRadius,
  borderBottomRightRadius: Styles.borderRadius,
  borderBottomLeftRadius: Styles.borderRadius,

  style: {
    shadowColor: Styles.shadowColor,
    shadowOffset: {
      width: 0,
      height: 0.5,
    },
    shadowRadius: 1.5,
    shadowOpacity: 1,
  },

  color: primitive.bk.$bbqBrown,
  fontFamily: 'body',
  padding: '$3',
  fontSize: 'md',
  marginTop: '$2',
}); /* TODO: RN - This was a <input> tag. Verify its styled properly*/

const ErrorMessage = Text.withConfig({
  color: Styles.color.error,
  margin: 0,
  fontSize: 'xs',
});

const Legend = Box.withConfig({
  _text: {
    fontSize: 'xl',
    fontWeight: 'bold',
  },

  marginTop: 0,
  marginRight: 0,
  marginBottom: '$4',
  marginLeft: 0,
}); /* TODO: RN - This was a <legend> tag. Verify its styled properly*/

const DescriptionContainer = FormControl.withConfig({
  borderWidth: 0,
  borderColor: 'black',
  borderStyle: 'solid',
  marginY: '$4',
}); /* TODO: RN - This was a <input> tag. Verify its styled properly*/

export const VehicleDescription: React.FC<React.PropsWithChildren<IVehicleDescriptionProps>> = ({
  onChange,
  value,
  hasError,
}) => {
  const { formatMessage } = useIntl();
  const curbsideVehicleDescriptionMaxLength = useFlag(
    LaunchDarklyFlag.CURBSIDE_VEHICLE_DESCRIPTION_MAX_LENGTH
  );

  const errorMessage = formatMessage(
    { id: 'descriptionLengthError' },
    {
      min: 1,
      max: curbsideVehicleDescriptionMaxLength,
    }
  );

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (description: string) => {
    const value = description?.trimStart();
    const isValid = curbsideVehicleDescriptionMaxLength
      ? value && value.length <= curbsideVehicleDescriptionMaxLength
      : true;
    onChange({ value: description, hasError: !isValid });
  };

  return (
    <DescriptionContainer>
      <Legend>{formatMessage({ id: 'describeYourVehicle' })}</Legend>
      {/*TODO: RN - This was a <label> tag. This should be converted to a UL <FormControl.Label>*/}
      <Text>{formatMessage({ id: 'curbsideVehicleDescription' })}</Text>
      <DescriptionInput
        testID="vehicle-description"
        placeholder={formatMessage({ id: 'curbsideVehicleDescriptionPlaceholder' })}
        onChangeText={handleChange}
        value={value}
        ref={inputRef}
      />
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </DescriptionContainer>
  );
};
